import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/common/state/stores/authStore'
import { saveReferralContext } from '@/web/composables/useReferralContext'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/invite/:code',
      name: 'invite',
      beforeEnter: (to) => {
        const code = String(to.params.code || '').trim()
        if (code) {
          saveReferralContext(code)
        }
        // If already logged in, go to app; otherwise login (invite does not clear session)
        const authStore = useAuthStore()
        return { path: authStore.isAuthenticated ? '/' : '/login' }
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/web/pages/LoginPage.vue')
    },
    {
      path: '/auth/complete',
      name: 'auth-complete',
      component: () => import('@/web/pages/AuthCompletePage.vue')
    },
    {
      path: '/initialization',
      name: 'web-initialization',
      component: () => import('@/web/pages/InitializationPage.vue')
    },
    {
      path: '/',
      name: 'download',
      component: () => import('@/web/pages/DownloadPage.vue')
    },
    {
      path: '/connected-apps',
      name: 'connected-apps',
      component: () => import('@/web/pages/ConnectedAppsPage.vue')
    },
    {
      path: '/download',
      redirect: '/'
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/login'
    }
  ]
})

export default router
